/* styled-components & other non-external style-related exports (like, say, a `headerHeight` var) go here */
import { font, colors, spacing } from '@chegg-ui/theme';
import styled from 'styled-components';
var weight = font.weight,
    family = font.family;
var sizeMap = {
  large: 88,
  medium: 48,
  small: 24
};

var getSize = function getSize(size) {
  return sizeMap[size];
};

var getFontSize = function getFontSize(size) {
  switch (size) {
    case 'small':
      return '1rem';

    case 'medium':
      return "".concat(36 / 16, "rem");

    default:
      return "".concat(48 / 16, "rem");
  }
};

export var AvatarImg = styled.img.withConfig({
  componentId: "iw4p3l-0"
})(["height:100%;width:100%;object-fit:cover;height:", "rem;width:", "rem;border-radius:50%;"], function (_ref) {
  var size = _ref.size;
  return getSize(size) / 16;
}, function (_ref2) {
  var size = _ref2.size;
  return getSize(size) / 16;
});
export var AvatarCircle = styled.span.withConfig({
  componentId: "iw4p3l-1"
})(["display:inline-flex;align-items:center;justify-content:center;font-weight:", ";font-size:", ";height:", "rem;width:", "rem;border-radius:50%;color:", ";background-color:", ";padding:", " 0 0;box-sizing:border-box;overflow:hidden;"], weight.heavy, function (_ref3) {
  var size = _ref3.size;
  return getFontSize(size);
}, function (_ref4) {
  var size = _ref4.size;
  return getSize(size) / 16;
}, function (_ref5) {
  var size = _ref5.size;
  return getSize(size) / 16;
}, colors.white, colors.dark, function (_ref6) {
  var size = _ref6.size;
  return size === 'small' ? '3px' : '5px';
});
export var AvatarContent = styled.span.withConfig({
  componentId: "iw4p3l-2"
})(["font-weight:", ";font-size:", "rem;color:", ";margin-left:", ";display:flex;align-items:center;svg{margin-left:-", ";}"], weight.medium, 14 / 16, colors.dark, spacing.px8, spacing.px4);
export var AvatarContainer = styled.div.withConfig({
  componentId: "iw4p3l-3"
})(["display:inline-flex;align-items:center;justify-content:center;font-family:", ";user-select:none;"], family["default"]);
export var UploadAvatarContainer = styled(AvatarContainer).withConfig({
  componentId: "iw4p3l-4"
})(["border:0;padding:0;background-color:", ";", "{padding:0;background-color:", ";color:", ";cursor:pointer;}"], colors.transparent, AvatarCircle, colors.greyLight, colors.grey);